export const colors = {
  textMain: '#434343',
  textSecondary: '#434343b3',
  labelText: 'rgba(67, 67, 67, 0.7)',
  placeholderText: 'rgba(61, 77, 105, 0.7)',

  primary: '#434343',
  secondary: '#F3F5F9',
  primaryLight: '#eaf9f7',
  primaryDisabled: '#dce2ef',

  success: '#4AB37B',
  successMedium: '#d4f4ee',
  successLight: '#CCEBDA',

  warning: '#EA9F48',
  warningMedium: '#fad59d',
  warningLight: '#fdf3e4',

  error: '#EF717D',
  errorMedium: '#ffacb4',
  errorLight: '#fff6f7',
  errorDisabled: '#ffc7cc',

  purple: '#6f7aff',
  purpleMedium: '#9a96f9',
  purpleLight: '#d9d7fc',

  blue: '#4d94fb',
  blueMedium: '#98c3ff',
  blueLight: '#d2e4fe',

  violet: '#6776CB',

  gray: '#7f9dbf', // mark as paid
  grayMedium: '#B0CBD6', // save as draft
  grayLight: '#CDE2EA',
  grayHover: '#8DADBA',

  sand: '#AF9B89',
  sandMedium: '#CCBAA9',
  sandLight: '#F4E3D4',

  // plan gray color
  planGray: '#6686a2',
  playGrayLight: '#eaf2f9',

  blackButton: '#465065',
  focusShadow: '#F5F5F5',

  white: '#fff',
  whiteBg: '#fcfdfe',

  details: '#EFB36D',
};

export const hoverColors = {
  primary: '#313131',
  error: '#ed5160',
  warning: '#f09b16',
  purpleMedium: '#8985ea',
  blue: '#3f86f0',
  gray: '#6d8caf',
  grayMedium: '#8ea1b5',
  planGray: '#617f9a',
  blackButton: '#1f2939',
};

export const dashboardColors = {
  total_employees: '#7F9DBF',
  working_today: '#41CB8F',
  not_working_today: '#C83A6E',
  total: '#916246',
  all_tasks: '#916246',
  in_progress: '#916246',
  open: '#D9A777',
  to_do: '#D9A777',
  not_completed: '#4A90E2',
  partially_completed: '#4A90E2',
  partially_complete: '#4A90E2',
  missed: '#F7B955',
  totally_missed: '#F7B955',
  completed: '#72CC6D',
  complete: '#72CC6D',
  pending_approval: '#B48963',
  approved: '#27AE60',
  rejected: '#E0627A',
};

export const dashboardStatusColors = {
  to_do: '#7f9dbf',
  complete: '#4AB37B',
  partially_complete: '#EA9F48',
  in_progress: '#916246',
  totally_missed: '#EF717D',
  not_completed: 'black',
};

export const borderColors = {
  primary: colors.primary,
  secondary: '#c2cce1',
  secondaryLight: '#e4e7eb',
  blackButton: '#1f2939',
  error: colors.error,
};

export const hoverBorderColors = {
  secondaryLight: '#434343b3',
};
